<template>
  <div>
    <div class="home-card card" @click="goToNext(homeSummary)">
      <div class="facade-image">
        <figure class="image is-3by2" v-if="homeSummary.facadelist.length">
          <img :src="homeSummary.facadelist[0].imageurl" alt="">
        </figure>
      </div>
      <div class="card-info">
        <div class="columns is-mobile is-gapless">
          <div class="column design">
            <p class="design">{{ homeSummary.designproductname }}</p>
            <p class="d">{{ homeSummary.ownername }}</p>
          </div>
          <div class="column is-narrow">
            <div class="amenities">
              <div class="amenity">
                <img :src="require('@/assets/icons/bed.svg')" alt="">
                <span>{{ homeSummary.noofbedrooms }}</span>
              </div>
              <div class="amenity">
                <img :src="require('@/assets/icons/bath.svg')" alt="">
                <span>{{ homeSummary.noofbathrooms }}</span>
              </div>
              <div class="amenity">
                <img :src="require('@/assets/icons/car.svg')" alt="">
                <span>{{ homeSummary.noofcarparks }}</span>
              </div>
            </div>
            <div class="price">
              <!--              <p class="f">From</p>-->
              <p class="p" v-if="homeSummary.productprice > 0">${{ homeSummary.productprice.toLocaleString() }}</p>
<p class="p" v-if="homeSummary.productprice === 0" style="font-size: 13px; text-wrap: wrap; max-width: 146px;">Contact builder for pricing.</p>            </div>
          </div>
        </div>
        <div class="columns is-mobile is-gapless">
          <div class="column dimensions">
            <div class="dimension">
              <p class="t">Home Area</p>
              <p class="d">{{ homeSummary.productsize.toLocaleString() }}<small> sq ft</small></p>
            </div>
          </div>
          <div class="column is-narrow">

            <a class="button app-accent">
              Select Home
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      // homeSummaryList: []
    }
  },
  props: {
    homeSummary: {
      type: Object
    },
    triggerSelect: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    locatePackage(hnl) {

    },

    viewDetail(hnl) {

    },

    goToNext(homesummary) {
      this.$store.dispatch('productTracking', {product: homesummary, page: 'home-design'})
      if (this.triggerSelect) {
        this.$emit('homeSelected', homesummary);
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/journey/home/HomeCard.vue